import { useSnapshot } from 'valtio'
import Pagination from '@mui/material/Pagination'
import React, { type ReactElement, useState } from 'react'
import { recurringPaymentsProxy } from '../../../recurringPaymentsProxy'
import { DEFAULT_LIMIT } from '../../../../../../../shared/utils/apiUtils'
import StandardTableFooterSummary from '../../../../../../../shared/components/ui/table/StandardTableFooterSummary'
import {
  executeRetrieveRecurringPaymentsSearch
} from '../../../../../../../shared/apiUtils/executeRetrieveRecurringPaymentsSearch'

export function RecurringPaymentsTableFooter (): ReactElement {
  const { pagination } = useSnapshot(recurringPaymentsProxy)

  const pageTotal = Math.ceil(pagination?.totalCount / DEFAULT_LIMIT)
  const [currentPage, setCurrentPage] = useState<number>(1)

  const handlePageChange = (page: number): void => {
    setCurrentPage(page)
    recurringPaymentsProxy.filters.offset = DEFAULT_LIMIT * (page - 1)
    void executeRetrieveRecurringPaymentsSearch({ displayLoader: false })
  }

  return (
    <div className="flex justify-between my-4 mx-4">
      <div>
        <StandardTableFooterSummary
          currentPage={currentPage}
          totalResults={pagination?.totalCount}
        />

      </div>
      <Pagination
        className="pb-4"
        count={pageTotal}
        page={currentPage}
        onChange={(event, page) => { handlePageChange(page) }}
      />

    </div>
  )
}
